import { useEffect, useState } from 'react';
import { Modal } from 'components-antd';
import styles from './styles.module.scss';
import { Button } from 'components';
import AppLogo from 'images/svg/app-logo.svg';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { appSetMobileModalClose } from 'store/actions/app';
import { getMobileModalCloseSelector } from 'store/selectors/app';

const MobileAppModal = () => {
  const dispatch = useDispatch();
  const excludedPaths = [
    '/login',
    '/signup',
    '/onboarding',
    '/radar',
    '/settings',
    '/enroll-account',
  ];
  const currentPath = window.location.pathname;
  const isExcluded = excludedPaths.some((url) => currentPath.includes(url));
  const closed = useSelector(getMobileModalCloseSelector);
  const [isMobile, setIsMobile] = useState(false);

  const setClosed = (val: boolean) => dispatch(appSetMobileModalClose(val));

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleRedirect = () => {
    const userAgent = navigator.userAgent || navigator.vendor;
    const appLink = 'mosaikhomes://';
    const androidStoreUrl = 'https://play.google.com/store/apps/details?id=com.mosaik.app&hl=en';
    const iosStoreUrl = 'https://apps.apple.com/pk/app/mosaik-io/id1579517790';

    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);

    window.location.href = appLink;

    setTimeout(() => {
      isAndroid
        ? (window.location.href = androidStoreUrl)
        : isIOS
        ? (window.location.href = iosStoreUrl)
        : null;
    }, 1500);
  };

  const handleClose = () => setClosed(true);

  return (
    <Modal
      open={isMobile && !isExcluded && !closed}
      footer={null}
      onCancel={handleClose}
      closeIconStyles={styles.closeIconStyles}
      className={styles.modal}
      maskClosable={false}
      destroyOnClose
      title=""
    >
      <div className={styles.modalContent}>
        <img src={AppLogo} alt="App Logo" />
        <p>Download the Mosaik app for a better mobile experience.</p>
        <Button className={styles.button} title={'Download'} onClick={handleRedirect} />
        <Button
          className={classNames(styles.button, styles.notNow)}
          title={'Not now'}
          onClick={handleClose}
        />
      </div>
    </Modal>
  );
};

export default MobileAppModal;
